import { AbstractControl } from "@angular/forms";

export function validLabelValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const value = control.value;
  
  if (!value) {
    return null; // Ne pas valider si vide (géré par required)
  }
  
  // 1. Vérifier si ce ne sont que des espaces
  if (/^\s*$/.test(value)) {
    return { 'onlySpaces': true };
  }
  
  // 2. Vérifier les caractères spéciaux (sauf tirets, underscores, apostrophes, espaces)
  // Permet : lettres, chiffres, espaces, tirets, underscores, apostrophes, points
  const pattern = /^[a-zA-Z0-9À-ÿ\s\-_()'\.]*$/;
  
  if (!pattern.test(value)) {
    return { 'specialCharacters': true };
  }
  
  // 3. Vérifier qu'il y a au moins un caractère non-espace
  if (!/[a-zA-Z0-9À-ÿ]/.test(value)) {
    return { 'noValidCharacters': true };
  }
  
  return null;
}